<template>
    <section class="services section" id="services">
        <h2 class="section__title">Services</h2>
        <span class="section__subtitle">What I Offer</span>

        <div class="services__container container grid">

            <!-- SERVICE CARD 1 -->
            <div class="services__content">
                <div>
                    <i class="uil uil-web-grid services__icon"></i>
                    <h3 class="services__title">Fullstack Web <br> Development</h3>
                </div>
                <span class="button button--flex button--small button--link services__button" @click="openModal(0)">
                    View More
                    <i class="uil uil-arrow-right button__icon"></i>
                </span>
            </div>

            <!-- SERVICE CARD 2 -->
            <div class="services__content">
                <div>
                    <i class="uil uil-server-connection services__icon"></i>
                    <h3 class="services__title">Backend & API <br> Engineering</h3>
                </div>
                <span class="button button--flex button--small button--link services__button" @click="openModal(1)">
                    View More
                    <i class="uil uil-arrow-right button__icon"></i>
                </span>
            </div>

            <!-- SERVICE CARD 3 -->
            <div class="services__content">
                <div>
                    <i class="uil uil-brackets-curly services__icon"></i>
                    <h3 class="services__title">Frontend <br> Development</h3>
                </div>
                <span class="button button--flex button--small button--link services__button" @click="openModal(2)">
                    View More
                    <i class="uil uil-arrow-right button__icon"></i>
                </span>
            </div>

            <!-- SERVICE CARD 4 -->
            <div class="services__content">
                <div>
                    <i class="uil uil-cloud-computing services__icon"></i>
                    <h3 class="services__title">Cloud & Deployment <br> Services</h3>
                </div>
                <span class="button button--flex button--small button--link services__button" @click="openModal(3)">
                    View More
                    <i class="uil uil-arrow-right button__icon"></i>
                </span>
            </div>

        </div>

        <!-- MODAL OVERLAY — rendered via teleport to body -->
        <teleport to="body">
            <div
                class="services__modal-overlay"
                :class="{ 'active-modal': activeModal !== null }"
                @click.self="closeModal"
            >
                <div v-if="activeModal !== null" class="services__modal-box">
                    <i class="uil uil-times services__modal-close" @click="closeModal"></i>
                    <h4 class="services__modal-title">{{ services[activeModal].title }}</h4>
                    <ul class="services__modal-services grid">
                        <li
                            v-for="(item, idx) in services[activeModal].items"
                            :key="idx"
                            class="services__modal-service"
                        >
                            <i class="uil uil-check-circle services__modal-icon"></i>
                            <p>{{ item }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </teleport>
    </section>
</template>

<script>
export default {
    name: 'Services',
    data() {
        return {
            activeModal: null,
            services: [
                {
                    title: 'Fullstack Web Development',
                    items: [
                        'Build end-to-end web applications from architectural design to deployment.',
                        'Integrate responsive frontend UI with robust backend REST APIs.',
                        'Develop custom web solutions for organization and client needs.',
                    ]
                },
                {
                    title: 'Backend & API Engineering',
                    items: [
                        'Develop scalable backend microservices with Node.js, Express, and PHP.',
                        'Design RESTful APIs and automation systems (e.g. WhatsApp Gateway).',
                        'Database design and management using MySQL, MongoDB, and SQLite.',
                    ]
                },
                {
                    title: 'Frontend Development',
                    items: [
                        'Build modern interactive UIs with JavaScript, TypeScript, React, and Vue.js.',
                        'Design pixel-perfect responsive layouts with Tailwind CSS & Bootstrap.',
                        'Optimize application performance and frontend user experience.',
                    ]
                },
                {
                    title: 'Cloud & Deployment Services',
                    items: [
                        'Deploy web applications on Linux VPS and Google Cloud Platform (GCP).',
                        'Containerize applications using Docker for consistent environments.',
                        'System monitoring, server maintenance, and automated deployments.',
                    ]
                },
            ]
        };
    },
    methods: {
        openModal(index) {
            this.activeModal = index;
            document.body.style.overflow = 'hidden';
        },
        closeModal() {
            this.activeModal = null;
            document.body.style.overflow = '';
        }
    }
}
</script>
